export default "__VITE_ASSET__CC_gkTIx__"